import { Component } from '@theme/component';
/** Hosted navigation enhancement; no credentials are collected or stored. */
class BroxRegister extends Component {
  #busy = false;
  #controller;
  #redirected = false;
  connectedCallback() {
    super.connectedCallback();
    this.#controller?.abort();
    this.#controller = new AbortController();
    window.addEventListener('pageshow', () => this.#reset(), { signal: this.#controller.signal });
    this.#openApp();
  }
  updatedCallback() { super.updatedCallback(); this.#reset(); this.#openApp(); }
  disconnectedCallback() { this.#controller?.abort(); super.disconnectedCallback(); }
  #openApp() {
    if (this.#redirected || this.dataset.autoRedirect !== 'true' || window.Shopify?.designMode) return;
    const destination = this.querySelector('a.brox-auth-action');
    if (!(destination instanceof HTMLAnchorElement)) return;
    const url = new URL(destination.href);
    if (url.protocol !== 'https:' || url.origin === window.location.origin) return;
    this.#redirected = true;
    window.location.replace(url.href);
  }
  /** @param {MouseEvent} event - Native hosted sign-in link activation. */
  handleContinue(event) {
    if (event.ctrlKey || event.metaKey || event.shiftKey || event.altKey || event.button !== 0) return;
    const link = event.target instanceof Element ? event.target.closest('a.brox-auth-action') : null;
    if (!(link instanceof HTMLAnchorElement)) return;
    if (this.#busy) { event.preventDefault(); return; }
    this.#busy = true;
    link.setAttribute('aria-busy', 'true');
    const label = link.querySelector('span');
    if (label) { link.dataset.originalLabel = label.textContent ?? ''; label.textContent = this.dataset.loading ?? ''; }
  }
  #reset() {
    this.#busy = false;
    for (const link of this.querySelectorAll('a.brox-auth-action')) {
      link.removeAttribute('aria-busy');
      const label = link.querySelector('span');
      if (label && link instanceof HTMLElement && link.dataset.originalLabel) label.textContent = link.dataset.originalLabel;
    }
  }
}
if (!customElements.get('brox-register-component')) customElements.define('brox-register-component', BroxRegister);
